<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>

    <b-row v-if="teacher">
      <b-col>
        <h2 class="purple bold">Estatísticas</h2>
        <p class="teacher-name">{{ teacher.User.name }}</p>
      </b-col>
    </b-row>

    <b-row v-if="teacher" class="mt-50">
      <b-col>
        <h3 class="bold">Avaliações do ano</h3>
        <div class="chart-box">
          <ui-chart
            v-if="isChartReady"
            id="myChart"
            :data="chartData"
            :options="stackedChartOptions"
            class="box-chart"
          ></ui-chart>
          <p v-else class="chart-loading">Carregando</p>

          <div v-if="isChartEmpty" class="chart-empty-overlay">
            <p class="chart-empty-message">
              Nenhuma avaliação registrada por esse(a) professor(a) neste ano
            </p>
          </div>
        </div>
      </b-col>
    </b-row>



    <b-row v-if="teacher" class="mt-50">
      <b-col>
        <h3 class="purple bold">Selecione um período</h3>
      </b-col>
    </b-row>

    <b-row v-if="teacher" class="mt-20">
      <b-col md="2">
        <b-form-group class="calendar">
          <label>De</label>
          <Datepicker
            v-model="statsStartDateFilter"
            placeholder="Selecione"
            format="dd/MM/yyyy"
            :use-utc="true"
            :language="languages[language]"
            @selected="callbackStatsStartDateFilter"
          >
          </Datepicker>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group class="calendar">
          <label>Até</label>
          <Datepicker
            v-model="statsEndDateFilter"
            placeholder="Selecione"
            format="dd/MM/yyyy"
            :use-utc="true"
            :language="languages[language]"
            @selected="callbackStatsEndDateFilter"
          >
          </Datepicker>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="teacher" class="mt-20">
      <b-col>
        <h3 class="bold">Visão geral por ciclo</h3>
      </b-col>
    </b-row>



    <b-row v-if="teacher && statistics" class="mt-20">
      <b-col>
        <div class="statements-card">
          <div>
            <p class="statements-label">Pareceres escritos no período</p>
            <p class="statements-value">{{ statistics.statements.count }}</p>
          </div>
          <p v-if="statistics.statements.last_created_at" class="statements-last">
            Último em {{ formatDate(statistics.statements.last_created_at) }}
          </p>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="teacher && statistics" class="mt-20">
      <b-col
        md="6"
        lg="4"
        v-for="cycle in statistics.cycles"
        :key="cycle.cycle_id"
        class="mb-4"
      >
        <div class="cycle-card">
          <div class="cycle-card-header">
            <h4 class="purple mb-0">{{ cycle.name }}</h4>
            <span v-if="cycle.designation" class="cycle-designation">
              {{ cycle.designation }}
            </span>
          </div>

          <div class="cycle-total">
            <span class="cycle-total-value">{{ cycle.total }}</span>
            <span class="cycle-total-label">
              {{ cycle.total === 1 ? "lançamento" : "lançamentos" }}
            </span>
          </div>

          <div class="cycle-block">
            <p class="cycle-block-title">Status</p>
            <div class="status-counts">
              <span
                v-for="item in statusItems(cycle)"
                :key="item.key"
                class="status-count"
                :class="{ 'status-count--empty': item.empty }"
                :style="item.empty ? {} : { backgroundColor: item.color }"
              >
                {{ item.label }} · {{ item.count }}
              </span>
            </div>
          </div>

          <div class="cycle-block">
            <p class="cycle-block-title">Tipo</p>
            <div class="type-counts">
              <span>
                Individual · {{ (cycle.type_counts && cycle.type_counts.individual) || 0 }}
              </span>
              <span>
                Coletiva · {{ (cycle.type_counts && cycle.type_counts.group) || 0 }}
              </span>
            </div>
          </div>

          <div
            class="cycle-block"
            v-if="cycle.tematic_units && cycle.tematic_units.length"
          >
            <p class="cycle-block-title">
            {{
              isMedioCycle(cycle.cycle_id) ? "Unidades temáticas/Competências" : "Unidades temáticas"
            }}
            </p>
            <b-form-input
              class="tematic-search"
              size="sm"
              type="search"
              :placeholder="`Buscar ${isMedioCycle(cycle.cycle_id) ? 'unidade temática/competência' : 'unidade temática'}`"
              :value="tematicSearch[cycle.cycle_id] || ''"
              @input="updateTematicSearch(cycle.cycle_id, $event)"
            ></b-form-input>
            <div class="tematic-units-scroll">
              <ul class="tematic-units">
                <li
                  v-for="unit in filteredTematicUnits(cycle)"
                  :key="unit.tematic_unit_id"
                >
                  <span class="tematic-name">{{ unit.name }}</span>
                  <span class="tematic-count">{{ unit.count }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </b-col>

      <b-col v-if="statistics.cycles.length === 0" md="12">
        <div class="cycle-empty">
          Nenhum ciclo encontrado para esse(a) professor(a)
        </div>
      </b-col>
    </b-row>

    <b-row v-if="teacher" class="mt-50">
      <b-col>
        <h3 class="purple bold">Selecione um período</h3>
      </b-col>
    </b-row>

    <b-row v-if="teacher" class="mt-20">
      <b-col>
        <div class="results-filter">
          <b-row>
            <b-col md="2">
              <b-form-group class="calendar">
                <label>De</label>
                <Datepicker
                  v-model="startDateFilter"
                  placeholder="Selecione"
                  format="dd/MM/yyyy"
                  :use-utc="true"
                  :language="languages[language]"
                  @selected="callbackStartDateFilter"
                >
                </Datepicker>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group class="calendar">
                <label>Até</label>
                <Datepicker
                  v-model="endDateFilter"
                  placeholder="Selecione"
                  format="dd/MM/yyyy"
                  :use-utc="true"
                  :language="languages[language]"
                  @selected="callbackEndDateFilter"
                >
                </Datepicker>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Aluno">
                <multiselect
                  v-model="selectedStudent"
                  :options="students"
                  :multiple="false"
                  placeholder="Selecione o aluno"
                  label="name"
                  track-by="id"
                  selectLabel=""
                  @input="callbackStudentFilter"
                >
                  <span slot="noResult">Nada encontrado</span>
                </multiselect>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="align-items-center results-filter-title">
            <h3 class="bold">Avaliações realizadas no período</h3>
            <h3 class="tags_count">{{ evaluationsCount }}</h3>
          </b-row>
        </div>
        <DataTable
          class="list-top"
          :items="evaluations"
          :fields="evaluationsFields"
          :busy="!isRequestSend"
          :primary-key="'id'"
          empty-text="Nenhuma avaliação encontrada"
        >
          <template #cell(created_at)="{ item }">
            <p>{{ formatDate(item.created_at) }}</p>
          </template>

          <template #cell(student)="{ item }">
            <p>{{ item.Student ? item.Student.User.name : "" }}</p>
          </template>

          <template #cell(subject)="{ item }">
            <p>{{ item.Subject ? item.Subject.designation : "" }}</p>
          </template>

          <template #cell(content)="{ item }">
            <p>{{ item.competence_sort_order }}.{{ item.topic_sort_order }}</p>
          </template>

          <template #cell(type)="{ item }">
            <p>{{ item.type }}</p>
          </template>

          <template #cell(assessment)="{ item }">
            <div class="status-transition">
              <span
                class="tags"
                style="margin: 3px 0 3px 0"
                :class="{ 'tag-empty': !item.old_status }"
                :style="
                  item.old_status
                    ? { backgroundColor: setStatusColor(item.old_status) }
                    : {}
                "
              >
                {{ item.old_status || "Vazio" }}
              </span>
              <span class="status-arrow">&#8594;</span>
              <span
                class="tags"
                 style="margin: 3px 0 3px 0"
                :class="{ 'tag-empty': !item.new_status }"
                :style="
                  item.new_status
                    ? { backgroundColor: setStatusColor(item.new_status) }
                    : {}
                "
              >{{ item.new_status || "Vazio" }}</span>
            </div>
          </template>
        </DataTable>

        <b-row class="align-center" v-if="evaluationsCount > perPage">
          <b-pagination
            v-model="page"
            :per-page="perPage"
            :total-rows="evaluationsCount"
            @change="changePage"
            aria-controls="evaluationsList"
            last-text
            first-text
          >
            <template #prev-text>
              <LeftArrowIcon class="left" />
            </template>
            <template #next-text>
              <LeftArrowIcon />
            </template>
          </b-pagination>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-else-if="loadError">
      <b-col class="text-center mt-50">
        <p>Ocorreu um problema ao carregar o Professor</p>
        <p>Por favor, atualize a pagina e tente novamente.</p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment-timezone";
import httpRda from "../../../http-rda";
import UiChart from "@/components/chart/chart.vue";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import LeftArrowIcon from "@/components/svg/LeftArrowIcon.vue";
import DataTable from "@/components/table/DataTable.vue";
import TopicsStudentsLogsService from "@/services/topicsStudentsLogs.service";
import { CHART_COLORS } from "@/utils/chartColors";

const MONTH_NAMES = [
  "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
  "Jul", "Ago", "Set", "Out", "Nov", "Dez",
];

export default {
  name: "professor-estatisticas",

  components: {
    UiChart,
    Datepicker,
    LeftArrowIcon,
    DataTable,
  },

  data() {
    return {
      ensinoMedioCycles: [4, 5],
      teacherId: null,
      teacher: null,
      loadError: false,

      evaluations: [],
      evaluationsCount: 0,
      isRequestSend: false,

      isChartReady: false,
      chartData: {
        labels: [],
        datasets: [{ label: "Avaliações", backgroundColor: "#b23066", data: [] }],
      },

      stackedChartOptions: {
        legend: {
          display: true,
          gap: 24,
        },
        scales: {
          xAxes: [{ stacked: true }],
          yAxes: [
            {
              stacked: true,
              ticks: { beginAtZero: true, min: 0, precision: 0 },
            },
          ],
        },
      },

      language: "ptBR",
      languages: lang,
      startDateFilter: null,
      endDateFilter: null,
      beginDateQuery: null,
      endDateQuery: null,

      students: [],
      selectedStudent: null,

      statsStartDateFilter: null,
      statsEndDateFilter: null,
      statsBeginDateQuery: null,
      statsEndDateQuery: null,

      tematicSearch: {},

      page: 1,
      perPage: 10,

      evaluationsFields: [
        { key: "created_at", label: "Data", thStyle: { textAlign: "center" } },
        { key: "student", label: "Aluno", thStyle: { textAlign: "center" } },
        {
          key: "subject",
          label: "Área do Conhecimento",
          thStyle: { textAlign: "center" },
        },
        { key: "content", label: "Conteúdo", thStyle: { textAlign: "center" } },
        { key: "type", label: "Tipo", thStyle: { textAlign: "center" } },
        {
          key: "assessment",
          label: "Avaliação",
          thStyle: { textAlign: "center" },
        },
      ],

      statistics: {
        cycles: [],
        statements: { count: 0, last_created_at: null },
      },

      breadcrumb: [],
    };
  },

  computed: {
    isChartEmpty() {
      if (!this.isChartReady) return false;

      const datasets = this.chartData.datasets || [];
      if (datasets.length === 0) return true;

      return datasets.every(
        (dataset) =>
          !Array.isArray(dataset.data) || dataset.data.every((count) => !count)
      );
    },
  },

  methods: {
    isMedioCycle(id) {
      return this.ensinoMedioCycles.includes(id);
    },

    async fetchTeacher() {
      try {
        const data = await httpRda
          .get(`/teachers/${this.teacherId}/edit`)
          .then((response) => response.data.teacher);

        this.teacher = {
          id: data.id,
          User: { ...data.User, id: data.user_id },
          Cycles: data.cycles || [],
          Subjects: data.subjects || [],
        };
      } catch (error) {
        this.loadError = true;
      }
    },

    async fetchStudents() {
      try {
        const response = await httpRda.get("/students-opt", {
          params: { teacher_id: this.teacher.id },
        });

        this.students = response.data.students;
      } catch (error) {
        this.students = [];
      }
    },

    async fetchEvaluations() {
      this.isRequestSend = false;

      try {
        const response = await TopicsStudentsLogsService.getAll({
          update_user_id: this.teacher.User.id,
          begin_date: this.beginDateQuery,
          end_date: this.endDateQuery,
          student_id: this.selectedStudent ? this.selectedStudent.id : undefined,
          page: this.page,
          pageSize: this.perPage,
        });

        this.evaluations = response.data.logs;
        this.evaluationsCount = response.data.count;
      } catch (error) {
        this.evaluations = [];
        this.evaluationsCount = 0;
      }

      this.isRequestSend = true;
    },

    async fetchStatistics() {
      try {
        const response = await TopicsStudentsLogsService.getStatistics({
          update_user_id: this.teacher.User.id,
          begin_date: this.statsBeginDateQuery,
          end_date: this.statsEndDateQuery,
        });

        this.statistics = {
          cycles: response.data.cycles || [],
          statements: response.data.statements || {
            count: 0,
            last_created_at: null,
          },
        };
      } catch (error) {
        this.statistics = {
          cycles: [],
          statements: { count: 0, last_created_at: null },
        };
      }
    },

    async fetchChartData() {
      this.isChartReady = false;

      try {
        const response = await TopicsStudentsLogsService.getMonthlyCounts({
          update_user_id: this.teacher.User.id,
        });

        this.chartData = this.buildChartData(response.data);
      } catch (error) {
        this.chartData = { labels: MONTH_NAMES, datasets: [] };
      }

      this.isChartReady = true;
    },

    buildChartData(data) {
      const cycles = data.cycles || [];

      return {
        labels: MONTH_NAMES,
        datasets: cycles.map((cycle, index) => {
          const countsByMonth = {};
          (cycle.months || []).forEach((entry) => {
            countsByMonth[entry.month] = entry.count;
          });

          return {
            label: cycle.name,
            backgroundColor: CHART_COLORS[index % CHART_COLORS.length],
            data: MONTH_NAMES.map(
              (_, monthIndex) => countsByMonth[monthIndex + 1] || 0
            ),
          };
        }),
      };
    },

    changePage(page) {
      this.page = page;
      this.fetchEvaluations();
    },

    callbackStartDateFilter(date) {
      const currentTzOffset = Math.abs(moment().utcOffset() / 60);
      this.beginDateQuery = moment(date)
        .add("day", currentTzOffset > 0 ? 1 : 0)
        .format("YYYY-MM-DD")
        .toString();

      if (this.endDateQuery && moment(this.beginDateQuery).isAfter(this.endDateQuery)) {
        this.$bvToast.toast("A data \"De\" não pode ser depois da data \"Até\".", {
          title: "Período inválido",
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.page = 1;
      this.fetchEvaluations();
    },

    callbackEndDateFilter(date) {
      const currentTzOffset = Math.abs(moment().utcOffset() / 60);
      this.endDateQuery = moment(date)
        .add("day", currentTzOffset > 0 ? 1 : 0)
        .format("YYYY-MM-DD")
        .toString();

      if (this.beginDateQuery && moment(this.endDateQuery).isBefore(this.beginDateQuery)) {
        this.$bvToast.toast("A data \"Até\" não pode ser antes da data \"De\".", {
          title: "Período inválido",
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.page = 1;
      this.fetchEvaluations();
    },

    callbackStudentFilter() {
      this.page = 1;
      this.fetchEvaluations();
    },

    callbackStatsStartDateFilter(date) {
      const currentTzOffset = Math.abs(moment().utcOffset() / 60);
      this.statsBeginDateQuery = moment(date)
        .add("day", currentTzOffset > 0 ? 1 : 0)
        .format("YYYY-MM-DD")
        .toString();

      if (
        this.statsEndDateQuery &&
        moment(this.statsBeginDateQuery).isAfter(this.statsEndDateQuery)
      ) {
        this.$bvToast.toast("A data \"De\" não pode ser depois da data \"Até\".", {
          title: "Período inválido",
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.fetchStatistics();
    },

    callbackStatsEndDateFilter(date) {
      const currentTzOffset = Math.abs(moment().utcOffset() / 60);
      this.statsEndDateQuery = moment(date)
        .add("day", currentTzOffset > 0 ? 1 : 0)
        .format("YYYY-MM-DD")
        .toString();

      if (
        this.statsBeginDateQuery &&
        moment(this.statsEndDateQuery).isBefore(this.statsBeginDateQuery)
      ) {
        this.$bvToast.toast("A data \"Até\" não pode ser antes da data \"De\".", {
          title: "Período inválido",
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.fetchStatistics();
    },

    formatDate(date) {
      return moment.tz(date, "America/Sao_Paulo").format("DD/MM/YYYY");
    },

    setStatusColor(status) {
      switch (status) {
        case "EE":
          return "#b23066";
        case "AN":
          return "#ffbb00";
        case "*":
          return "#8e8989";
        case "#":
          return "#a9a9a9";
        default:
          return "#68c5b7";
      }
    },

    statusItems(cycle) {
      const counts = cycle.status_counts || {};
      const items = ["A", "AN", "EE", "*", "#"].map((key) => ({
        key,
        label: key,
        count: counts[key] || 0,
        color: this.setStatusColor(key),
        empty: false,
      }));

      items.push({
        key: "",
        label: "Vazio",
        count: counts[""] || 0,
        color: null,
        empty: true,
      });

      return items;
    },

    updateTematicSearch(cycleId, value) {
      this.$set(this.tematicSearch, cycleId, value);
    },

    filteredTematicUnits(cycle) {
      const term = (this.tematicSearch[cycle.cycle_id] || "").trim().toLowerCase();
      const units = cycle.tematic_units || [];

      if (!term) {
        return units;
      }

      return units.filter((unit) => unit.name.toLowerCase().includes(term));
    },

    buildBreadcrumb() {
      this.breadcrumb = [
        {
          text: "Coordenação",
          href: "/coordenacao",
        },
        {
          text: "Estatísticas dos Professores",
          href: "/coordenacao/professores",
        },
        {
          text: this.teacher ? this.teacher.User.name : "Estatísticas",
          href: `/coordenacao/professores/${this.teacherId}/estatisticas`,
          active: true,
        },
      ];
    },
  },

  async created() {
    this.teacherId = this.$route.params.id;
    const routeTeacher = this.$route.params.teacher;

    const defaultStart = moment().subtract(6, "months");
    const defaultEnd = moment();

    this.beginDateQuery = defaultStart.format("YYYY-MM-DD");
    this.endDateQuery = defaultEnd.format("YYYY-MM-DD");
    this.startDateFilter = defaultStart.toDate();
    this.endDateFilter = defaultEnd.toDate();

    this.statsBeginDateQuery = defaultStart.format("YYYY-MM-DD");
    this.statsEndDateQuery = defaultEnd.format("YYYY-MM-DD");
    this.statsStartDateFilter = defaultStart.toDate();
    this.statsEndDateFilter = defaultEnd.toDate();

    if (routeTeacher && routeTeacher.User) {
      this.teacher = routeTeacher;
    } else {
      await this.fetchTeacher();
    }

    this.buildBreadcrumb();

    if (this.teacher) {
      this.fetchEvaluations();
      this.fetchChartData();
      this.fetchStatistics();
      this.fetchStudents();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.teacher-name {
  color: $grey4;
  margin-top: 4px;
}

.chart-box {
  position: relative;
  background-color: $white;
  border: 1px solid $grey5;
  border-radius: 10px;
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 15px;

  .chart-loading {
    margin: 0;
    text-align: center;
    padding: 140px 0;
    color: $grey4;
  }

  .chart-empty-overlay {
    position: absolute;
    top: 20px;
    right: 20px;
    bottom: 20px;
    left: 20px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 6px;
    background: linear-gradient(
      to bottom,
      rgba($white, 0.55) 0%,
      rgba($white, 0.92) 100%
    );
  }

  .chart-empty-message {
    margin: 0;
    padding: 0 24px;
    color: $grey4;
    font-size: 18px;
  }
}

.box-chart {
  width: 100%;
  height: 320px;
  box-sizing: border-box;
}

.tags_count {
  background-color: #68c5b7;
  border-radius: 3px;
  color: $white;
  margin-left: 10px;
  padding: 3px 10px;
  height: max-content;
}

.results-filter-title {
  margin-top: 20px;
}

.list-top {
  margin-top: 30px;
  margin-bottom: 30px;

  ::v-deep td {
    text-align: center !important;
  }
}

.list-teacher {
  background-color: $white;
  border: 1px solid $grey5;
  border-radius: 10px;
  margin-bottom: 15px;
  min-height: 80px;

  .col,
  [class*="col-"] {
    padding-left: 6px;
    padding-right: 6px;
  }

  p {
    margin: 0;
  }
}

.header-list-teacher {
  flex-wrap: nowrap;
  align-items: center;
  padding: 10px 0;
  padding-left: 0px !important;

  .col,
  [class*="col-"] {
    padding-left: 6px;
    padding-right: 6px;
  }

  p {
    margin: 0;
    white-space: nowrap;
  }
}

.status-transition {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.status-arrow {
  color: $grey4;
}

.tags {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  color: $white;
  font-weight: $bold;
  text-align: center;
  min-width: 40px;

  &.tag-empty {
    background-color: $grey6;
    color: $grey4;
    font-weight: $regular;
    font-style: italic;
  }
}

.statements-card {
  align-items: center;
  background-color: $white;
  border: 1px solid #e7e8ec;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  margin-bottom: 20px;
}

.statements-label {
  color: $grey4;
  font-size: 14px;
  margin: 0;
}

.statements-value {
  color: $purple;
  font-size: 28px;
  font-weight: $bold;
  line-height: 1.1;
  margin: 0;
}

.statements-last {
  color: $grey4;
  font-size: 13px;
  margin: 0;
  white-space: nowrap;
}

.cycle-card {
  background-color: $white;
  border: 1px solid #e7e8ec;
  border-radius: 12px;
  height: 100%;
  padding: 20px;
}

.cycle-card-header {
  align-items: baseline;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  margin-bottom: 12px;
}

.cycle-designation {
  color: $grey4;
  font-size: 13px;
  white-space: nowrap;
}

.cycle-total {
  align-items: baseline;
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
}

.cycle-total-value {
  color: $purple;
  font-size: 32px;
  font-weight: $bold;
  line-height: 1;
}

.cycle-total-label {
  color: $grey4;
  font-size: 14px;
}

.cycle-block {
  margin-bottom: 14px;

  &:last-child {
    margin-bottom: 0;
  }
}

.cycle-block-title {
  color: $grey4;
  font-size: 12px;
  font-weight: $bold;
  letter-spacing: 0.4px;
  margin: 0 0 6px;
  text-transform: uppercase;
}

.status-counts {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}

.status-count {
  align-items: center;
  border-radius: 6px;
  color: $white;
  display: inline-flex;
  font-size: 12px;
  font-weight: $bold;
  justify-content: center;
  padding: 4px 6px;
  white-space: nowrap;

  &.status-count--empty {
    background-color: $grey6;
    color: $grey4;
    font-weight: $regular;
    font-style: italic;
  }
}

.type-counts {
  color: $grey1;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  gap: 16px;
}

.tematic-search {
  margin-bottom: 8px;
}

.tematic-units-scroll {
  max-height: 160px;
  overflow-y: auto;
  padding-right: 12px;
}

.tematic-units {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    align-items: center;
    border-bottom: 1px dashed $grey6;
    color: $grey1;
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    padding: 4px 0;

    &:last-child {
      border-bottom: 0;
    }
  }

  .tematic-count {
    color: $grey4;
    font-weight: $bold;
  }
}

.cycle-empty {
  background-color: $white;
  border: 1px solid $grey5;
  border-radius: 10px;
  color: $grey4;
  padding: 20px;
  text-align: center;
}
</style>
